import styled from "styled-components";
const RadioDiv = styled.div`
  position: relative;
  & label {
    display: flex;
  }
  & input[type="radio"] {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
    font: inherit;
    color: currentColor;
    width: 1.15em;
    height: 1.15em;
    border: 0.15em solid currentColor;
    border-radius: 50%;
    transform: translateY(-0.075em);
    display: grid;
    place-content: center;
    margin-right: 15px
  }
  & input[type="radio"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    background-color: CanvasText;
  }

  & input[type="radio"]:checked::before {
    transform: scale(1);
  }

  & input[type="radio"]:focus {
    outline-offset: max(2px, 0.15em);
  }

`;

const BetTypeLi = styled.li`
background: none;
padding: 0;
`;
export { RadioDiv, BetTypeLi };
